import {Component, OnInit} from '@angular/core';
import {UnidadesMedidasService} from "./unidades-medidas.service";
import {UnidadesMedidasModel} from "./unidades-medidas.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-unidades',
  templateUrl: './unidades-medidas.component.html'
})
export class UnidadesMedidasComponent extends Components implements OnInit {

  unidades: UnidadesMedidasModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private unidadesService: UnidadesMedidasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'defeitos'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.unidadesService.getPaginacao(1,this.itensPorPagina)
      .subscribe(data => {
        this.unidades = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.unidades);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });


  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.unidadesService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.unidades = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/unidades-medidas/unidades-medidas.component.ts